import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { cssVar } from "./colors";

interface StyledLinkProps {
	hideMarkIfVisited?: boolean;
}
const StyledLink = styled.a<StyledLinkProps>(
	({ hideMarkIfVisited }) => css`
		font-size: 0.9em;
		padding: 2px 4px;
		cursor: pointer;
		transition: 100ms color;
		color: ${cssVar("blue")};
		text-decoration: underline;
		border-radius: ${cssVar("border-radius-1")};
		border: 2px solid transparent;
		&:focus-visible {
			outline: none;
			border: 2px solid ${cssVar("blue")};
		}
		&:hover,
		&:focus-visible {
			border: 2px solid ${cssVar("blue")};
		}
		&:active {
			color: ${cssVar("purple-dark")};
			border-color: ${cssVar("purple-dark")};
		}
		${!hideMarkIfVisited
			? css`
					&:visited {
						color: ${cssVar("purple")};
						&:hover,
						&:focus-visible {
							border: 2px solid ${cssVar("purple")};
						}
						&:active {
							color: ${cssVar("purple-dark")};
							border-color: ${cssVar("purple-dark")};
						}
					}
			  `
			: ""}
	`
);

/**
 * Overrides the default Link props.
 */
export const Link = (
	props: StyledLinkProps &
		React.ClassAttributes<HTMLAnchorElement> &
		React.AnchorHTMLAttributes<any>
) => {
	return (
		<StyledLink tabIndex={0} {...props}>
			{props.children}
		</StyledLink>
	);
};
